import React from 'react';
import { Button } from '../../../components/ui';

/**
 * Submit bar shared by both QDF forms.
 *
 * Sticks to the bottom of the viewport on mobile so the primary action stays
 * reachable without scrolling to the end of a long form; it sits inline from
 * `sm` upward where the whole form is closer to visible at once.
 */
const FormActions = ({ onCancel, loading, isEditing, submitLabel }) => {
  const label =
    submitLabel ||
    (loading
      ? isEditing
        ? 'Updating & generating PDF…'
        : 'Saving & generating PDF…'
      : isEditing
        ? 'Update & export PDF'
        : 'Save & export PDF');

  return (
    <div
      className={[
        'z-10 -mx-4 flex gap-3 border-t border-border bg-surface/95 px-4 py-3 backdrop-blur',
        'sm:mx-0 sm:justify-end sm:border-0 sm:bg-transparent sm:px-0 sm:py-0 sm:backdrop-blur-none',
      ].join(' ')}
    >
      <Button type="button" variant="secondary" size="lg" onClick={onCancel} disabled={loading}>
        Cancel
      </Button>
      <Button type="submit" size="lg" loading={loading} className="flex-1 sm:flex-none">
        {label}
      </Button>
    </div>
  );
};

export default FormActions;
